import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'localizedDate',
    pure: false
})
export class LocalizedDatePipe implements PipeTransform {
    constructor(private translateService: TranslateService) { }

    transform(value: any, pattern: string = 'mediumDate'): any {
        if (!value) return value;

        const datePipe: DatePipe = new DatePipe(this.translateService.currentLang);

        let format = '';
        while (true) {
            if (pattern === 'voiteqDate' || pattern === 'voiteqDateShortTime' || pattern === 'voiteqDateTime' || pattern === 'voiteqDateFullTime') {
                format = this.translateService.instant('date.dateInput');
                if (format === 'date.dateInput') {
                    format = '';
                    break;
                }
                format = format.replace(/D/g, 'd').replace(/Y/g, 'y');

                if (pattern === 'voiteqDate') break;

                format += ' HH:mm';
                if (pattern === 'voiteqDateShortTime') break;

                format += ':ss';
                if (pattern === 'voiteqDateTime') break;

                format += '.SSS';
                if (pattern === 'voiteqDateFullTime') break;
            }
            break;
        }
        if (format !== '') pattern = format;

        return datePipe.transform(value, pattern);
    }
}